import Highcharts from 'highcharts';

export function toggleVerticalGridLines(value: string): void {
	const gridLineWidth = Number(value) ? 2 : 0;

	// redraw all charts
	Highcharts.charts.forEach(function (chart) {
		if (chart && ((chart.options.xAxis as any)[0]?.type === 'datetime' || chart.options.chart?.renderTo === 'frcst')) {
			chart.update({
				xAxis: {
					gridLineWidth: gridLineWidth,

				},
			});
		}
	});
}
